export const REACT_APP_CHAIN_ID = '56'
export const REACT_APP_GTAG = 'GTM-PXLD3XW'

// 10+ nodes balanced, US/EU
export const REACT_APP_NODE_1 = 'https://bsc-dataseed1.ninicoin.io'

// 10+ nodes balanced, US/EU
export const REACT_APP_NODE_2 = 'https://bsc-dataseed1.defibit.io'

// 10+ nodes balanced in each region, global
export const REACT_APP_NODE_3 = 'https://bsc-dataseed.binance.org'

export const BSC_TESTNET_1 = 'https://data-seed-prebsc-1-s1.binance.org:8545'
export const BSC_TESTNET_2 = 'https://data-seed-prebsc-2-s1.binance.org:8545'
export const BSC_TESTNET_3 = 'https://data-seed-prebsc-1-s2.binance.org:8545'
